import { TextWindow } from './TextWindow';
import { TextWindowFooter } from './TextWindowFooter';

export { TextWindow, TextWindowFooter };
